// extracted by mini-css-extract-plugin
export default {"dropdown":"styled_dropdown__5zUKO"};